import SpotifyAuthorization from '@/views/SpotifyAuthorization.vue';

export default [
  {
    path: 'spotify-authorization',
    name: 'spotify.authorization',
    component: SpotifyAuthorization,
    meta: {
      requiresFinishedWizard: true,
    },
  },
];
